import { isLowesPublicPath } from './lowes-path.ts'
import { isQrPublicPath } from './qr-path.ts'

/**
 * Should this page load start Sentry in the browser?
 *
 * Browser Sentry here means tracing at 100% plus session replay: a third party
 * records what the person does on the page, and the address they opened, which
 * on the Lowe's form carries ?ref=. Staff have agreed to that; members of the
 * public using the no-login form have not, and the server-side scrubbing never
 * sees what the browser sends. So it is not started at all when the page that
 * was loaded is the public form. Decided once, from the address the document
 * was loaded at: the form links nowhere else in the app.
 *
 * The same holds for the public QR pages (/qr, and the careers form where an
 * applicant types their details): every page there is its own document load
 * (plain links and a plain form), so each one decides again.
 */
export function shouldStartClientSentry(
	env: { MODE?: string; SENTRY_DSN?: string },
	pathname: string,
): boolean {
	return (
		env.MODE === 'production' &&
		Boolean(env.SENTRY_DSN) &&
		!isLowesPublicPath(pathname) &&
		!isQrPublicPath(pathname)
	)
}
